<template lang="pug">
    model-data-table(
        :no-actions="!$can('VIEW_DETAIL_PURCHASE_PROVIDER')"
        no-remove
        remind-key='provider-list'
        v-bind="tableProps"
        @detail="submitUpdate"
        )
</template>

<script>
//
import { mapActions } from "vuex"
import { ModelDataTable } from "@/components/reusable_components/next"
import ProviderModel from "@/models/Purchase/PchProvider"
//
import ProviderFilters from "./partials/ProviderFilters"
import ProviderHeaders from "./partials/ProviderHeaders"
//
export default {
    name: "provider-list",
    components: {
        ModelDataTable,
    },
    computed: {

        /**
         * 
         */
        tableProps() {
            return {
                filters: ProviderFilters,
                headers: ProviderHeaders,
                service: ProviderModel,
            }
        }
    },
    methods: {

        /**
         *
         */
        ...mapActions("MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
        }),

        /**
         * 
         */
        submitUpdate(event) {
            this.$router.push({ name: "provider-update", params: { id: event.item.id } })
        },
    },
    beforeMount() {
        this.setTitleTopBar("Proveedores")
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can("VIEW_ALL_PURCHASE_PROVIDER")) ctx.$router.push("/")
        })
    },
}
</script>